module.exports = __webpack_public_path__ + "img/KP.43d3be49.png";